/**
 * @type {import('grommet').ThemeType}
 */
const zoolifeTheme = {
  anchor: {
    color: 'var(--charcoalLight)',
    fontWeight: 400,
    textDecoration: 'underline',
  },
  checkBox: {
    size: '20px',
    color: {
      light: 'white',
    },
    toggle: {
      size: '42px',
      color: {
        light: 'white',
      },
      knob: {
        extend: {
          width: '16px',
          height: '16px',
          top: '0',
          backgroundColor: 'var(--white)',
        },
      },
      extend: ({ checked }) => `
        background-color: ${checked ? 'var(--blue);' : 'var(--mediumGrey)'}
      `,
    },
    check: {
      extend: ({ checked }) => `
        background-color: ${checked ? 'var(--primaryGreen)' : 'transparent'};
        ${checked ? 'border: 0;' : ''}
      `,
    },
  },
  global: {
    colors: {
      brand: 'var(--primaryGreen)',
      text: {
        light: 'black',
      },
    },
    focus: {
      border: {
        color: 'transparent',
      },
      shadow: {
        size: '0',
      },
    },
    drop: {
      border: {
        radius: '5px',
      },
    },
    breakpoints: {
      xsmall: {
        value: 440,
      },
      small: {
        value: 568,
      },
      medium: {
        value: 768,
      },
      large: {
        value: 1024,
      },
    },
    font: {
      family: 'var(--fontFamily)',
      size: '16px',
      lineHeight: '22px',
    },
  },
  heading: {
    level: {
      1: {
        medium: {
          size: '45px',
          height: '52px',
          maxWidth: '100%',
        },
      },
      2: {
        medium: {
          size: '35px',
          height: '42px',
          maxWidth: '100%',
        },
      },
      3: {
        medium: {
          size: '25px',
          height: '32px',
          maxWidth: '100%',
        },
      },
      4: {
        medium: {
          size: '20px',
          height: '28px',
          maxWidth: '100%',
        },
      },
      5: {
        medium: {
          size: '16px',
          height: '26px',
          maxWidth: '100%',
        },
      },
      6: {
        medium: {
          size: '15px',
          height: '25px',
        },
      },
    },
  },
  text: {
    font: 'var(--fontFamily)',
    // "Body" in Figma
    xlarge: {
      size: '16px',
      height: '22px',
    },
    // "Subhead" in Figma
    large: {
      size: '13px',
      height: '18px',
    },
    // "Caption" in Figma
    medium: {
      size: '12px',
      height: '18px',
    },
    // "Sub-caption" in Figma
    small: {
      size: '10px',
      height: '16px',
    },
    // "Highlight" in Figma
    highlight: {
      size: '10px',
      height: '10px',
    },
  },
  button: {
    default: {
      color: 'var(--primaryGreen)',
      background: {
        color: 'var(--white)',
      },
      border: {
        width: '1.5px',
        color: 'var(--primaryGreen)',
      },
      font: {
        weight: 'bold',
      },
    },
    primary: {
      color: 'white',
      background: {
        color: 'var(--primaryGreen)',
      },
      font: {
        weight: 'bold',
      },
    },
    secondary: {
      color: 'var(--primaryGreen)',
      background: {
        color: 'var(--white)',
      },
      border: {
        width: '1.5px',
        color: 'var(--primaryGreen)',
      },
      font: {
        weight: 'bold',
      },
    },
    disabled: {
      default: {
        color: 'var(--grey)',
        background: {
          color: 'white',
        },
      },
      primary: {
        color: 'var(--grey)',
        background: {
          color: 'var(--lightGrey)',
        },
      },
      border: {
        color: 'var(--lightGrey)',
      },
      color: 'var(--grey)',
      opacity: '1',
    },
    size: {
      large: {
        pad: {
          vertical: '11px',
          horizontal: '20px',
        },
      },
      medium: {
        pad: {
          vertical: '7px',
          horizontal: '20px',
        },
      },
      small: {
        pad: {
          vertical: '3px',
          horizontal: '16px',
        },
      },
    },
    hover: {
      default: {
        border: {
          color: 'var(--primaryGreen)',
        },
      },
      primary: {
        color: 'white',
        background: {
          color: 'var(--secondaryGreen)',
        },
      },
      secondary: {
        color: 'white',
        background: {
          color: 'var(--secondaryGreen)',
        },
      },
    },
    extend: {
      borderRadius: '50px',
      lineHeight: 'initial',
    },
  },
  menu: {
    extend: {
      minHeight: '30px',
    },
  },
  layer: {
    responsiveBreakpoint: null,
    container: {
      extend: {
        maxWidth: 'calc(100vw - 30px)',
        maxHeight: 'calc((100 * var(--vh)) - 30px)',
      },
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.75)',
    },
    border: {
      radius: '5px',
    },
  },
  select: {
    container: {
      extend: {
        button: {
          borderRadius: '0',
          '&[aria-selected="true"]:not(:hover)': {
            color: 'white',
          },
        },
      },
    },
  },
  dataTable: {
    pinned: {
      header: {
        background: 'white',
      },
    },
  },
};

export default zoolifeTheme;
